import { ContentTabs, PracticeContent, Tab } from '../components';
import React, { Fragment, useEffect, useState } from 'react';
import { gql, useQuery } from '@apollo/client';

import { Content } from 'react-bulma-components';
import DefaultError from '../components/defaulterror';
import Exercise from '../containers/exercise';
import { Loader } from '../components';
import Markdown from '../components/markdown';
import Player from 'components/Player/Player';
import SheetContainer from '../components/sheetcontainer';
import { StepContent } from '../components';

export const GET_SONGSTEP = gql`
  query GetSongStepById($slug: String!, $stepid: String!) {
    songStepById(slug: $slug, stepid: $stepid){
      id
      no
      keytonic
      title
      description
      explanation
      practice{
        no
        title
        description
        keytonic
        refid
        audio
        allowUserKey
      }
      scoremarks{
          pos
          a
          b
          to
          bc
        }
    }
    songBySlug(slug: $slug){
      ... on Song {
        id
        type
        title
        slug
        keytonic
        content
        refid
      }
    }
  }
`;
const SongStepContent = ({ songStep, skipInstrumentTransponation }) => {
  return (
    <Content>
      {songStep.practice && songStep.practice.map((practice, i) =>
        <Fragment key={i}>
          {practice.refid ?
            <Exercise id={practice.refid} keytonic={practice.keytonic} allowUserKey={practice.allowUserKey}  skipInstrumentTransponation={skipInstrumentTransponation}/>
            :
            <PracticeContent title={practice.title} description={practice.description} allowUserKey={practice.allowUserKey} org_keytonic={practice.keytonic}  keytonic={practice.keytonic} skipInstrumentTransponation={skipInstrumentTransponation}/>
          }
        </Fragment>
      )}
    </Content>
  );
}

const SongStep = ({ slug, stepid, skipInstrumentTransponation }) => {
  console.log("SongStep " + stepid);
  const [currentStepTab, setCurrentStepTab] = useState("Chord chart");
  const { data, loading, error } = useQuery(
    GET_SONGSTEP,
    { variables: { slug: slug, stepid: stepid } }
  );

  useEffect(() => {
    setCurrentStepTab("Chord chart");
  }, [stepid]);

  if (error) return <DefaultError error={error} />//<p>SongStep ERROR {error.message}</p>;
  if (loading) return (
    <Loader />
  );

  /*   var practices = [];
    if(data.songStep && data.songStep.practice){
      practices = data.songStep.practice.sort((a, b) => (a.no > b.no)  ? 1 : -1);
    } */
  if (!data.songStepById) {
    return null;
  }
  if (data.songBySlug.type !== "song") {
    return (
      <Fragment>
        <StepContent header={data.songStepById.title} description={data.songStepById.description} explanation={data.songStepById.explanation} keytonic={data.songStepById.keytonic} skipInstrumentTransponation={skipInstrumentTransponation}/>
        <SongStepContent songStep={data.songStepById} skipInstrumentTransponation={skipInstrumentTransponation}/>
      </Fragment>
    );
  }
  else {
    return (
      <Fragment>
        <StepContent header={data.songStepById.title} description={data.songStepById.description} explanation={data.songStepById.explanation} keytonic={data.songStepById.keytonic} />
        <ContentTabs active={currentStepTab} onTabClick={setCurrentStepTab}>
          <Tab label="Chord chart">
            <SheetContainer title={data.songBySlug.title}>
              <Markdown objectProps={
                { 
                  keytonic: data.songBySlug.keytonic,
                  scoreProps: { scoremarks: data.songStepById.scoremarks }
                }
                }>{data.songBySlug.content}</Markdown>
            </SheetContainer>
          </Tab>
          <Tab label="Practice" disabled={data.songStepById.practice.length===0}>
            <SongStepContent songStep={data.songStepById}  keytonic={data.songStepById.keytonic} skipInstrumentTransponation={skipInstrumentTransponation}/>
          </Tab>
        </ContentTabs>
      </Fragment>
    )
  }
}

export default SongStep;